import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/my-clans/$tag/permissions")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/my-clans/$tag/players",
      params: { tag: params.tag },
      replace: true,
    });
  },
});
